import { render, staticRenderFns } from "./RequestAutoAssignWorkTypes.vue?vue&type=template&id=380680a6&"
import script from "./RequestAutoAssignWorkTypes.vue?vue&type=script&lang=js&"
export * from "./RequestAutoAssignWorkTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCheckbox} from 'quasar'
component.options.components = Object.assign({QCheckbox}, component.options.components || {})
